'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectModel = getSelectModel;
exports.getSelectIdField = getSelectIdField;
exports.getSelectShowField = getSelectShowField;
exports.isSelectDefinedBothField = isSelectDefinedBothField;
exports.isSelectServerMode = isSelectServerMode;
exports.isSelectLocalMode = isSelectLocalMode;
exports.buildSelectData = buildSelectData;
exports.buildMultiSelectData = buildMultiSelectData;

var _index = require('./index');

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 主要是提供对 select 系列组件的数据做处理时的函数
 * 推荐使用 idField, showField 的数据格式, 兼容 label, value 形式
 */
function getSelectModel() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  return (field.conf || {}).model || field.model || {};
}
function getSelectIdField() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (_.isEmpty(field)) {
    return 'value';
  }
  var model = getSelectModel(field);
  return model.idField || "value";
}
function getSelectShowField() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (_.isEmpty(field)) {
    return 'label';
  }
  var model = getSelectModel(field);
  return model.showField || "label";
}
function isSelectDefinedBothField() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (_.isEmpty(field)) {
    return false;
  }
  var model = getSelectModel(field);
  return model.idField && model.showField;
}

// select 是否 server 模式 即idField
// showField 可能并不存在
function isSelectServerMode() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var data = arguments[1];

  if (_.isEmpty(field)) {
    return;
  }
  var model = getSelectModel(field);
  return model.idField && !(0, _index.isEmptyString)(data[model.idField]);
}
// select 是否 local 模式 即label,value都存在
function isSelectLocalMode() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var data = arguments[1];

  if (_.isEmpty(field)) {
    return;
  }
  return data.hasOwnProperty('value') && data.hasOwnProperty('label');
}

/**
 * 单选情况下的数据处理
 * @param field  用来处理多选的数据时传入的 {model}
 * @param data   具体的数据: bill 处理 defaultValue, select 处理 props.value
 * @param warn   如果是 label, value 模式是否需要报警提示
 * @returns {Object}  返回处理好的数据
 */
function buildSelectData() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var data = arguments[1];
  var warn = arguments[2];

  if (_.isEmpty(field)) {
    return;
  }
  var model = getSelectModel(field);
  var renderData = {};
  var needWarn = false;
  if (data) {
    if (typeof data === 'string') {
      !needWarn && (needWarn = true);
      renderData = {
        "value": data,
        "label": data
      };
    } else if (_.isObject(data)) {
      if (isSelectLocalMode(field, data)) {
        !needWarn && model.idField && model.idField !== "value" && (needWarn = true);
        renderData = data;
      } else {
        renderData = Object.assign({}, data, {
          "value": (0, _index.getSafetyString)(data[model.idField]),
          "label": model.showTpl ? _util2.default.template(model.showTpl, data) : (0, _index.getSafetyString)(data[model.showField])
        });
      }
    }
    warn && needWarn && console.warn((field.code ? field.code + "数据格式问题, " : "") + 'select/treeSelect 类型组件支持的数据格式 {label:"", value:""} 将被废弃, 请使用 {${showFiled}:"", ${idField}:"", ...otherCode} 代替');
  }
  return renderData;
}
/**
 * 多选情况下的数据处理
 * @param field  用来处理多选的数据时传入的 {model}
 * @param data   具体的数据: bill 处理 defaultValue, select 处理 props.value
 * @param warn   如果是 label, value 模式是否需要报警提示
 * @returns {Array}  返回处理好的数据
 */
function buildMultiSelectData() {
  var field = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var data = arguments[1];
  var warn = arguments[2];

  if (_.isEmpty(field)) {
    return;
  }
  var model = getSelectModel(field);
  var renderData = [];
  if (data && _.isArray(data) && data.length > 0) {
    var needWarn = false;
    if (data.some(function (obj) {
      return !isSelectLocalMode(field, obj);
    })) {
      // 如果不是所有都有 local 模式, 即 server 模式
      data.forEach(function (obj) {
        if (typeof obj === 'string') {
          !needWarn && (needWarn = true);
          renderData.push({
            "value": obj,
            "label": obj
          });
        } else if (_.isObject(obj)) {
          if (!isSelectServerMode(field, obj)) {
            !needWarn && (needWarn = true);
          } else {
            renderData.push(Object.assign({}, obj, {
              "value": (0, _index.getSafetyString)(obj[model.idField]),
              "label": model.showTpl ? _util2.default.template(model.showTpl, obj) : (0, _index.getSafetyString)(obj[model.showField])
            }));
          }
        }
      });
    } else {
      // 否则全是 local 模式
      model.idField && model.idField !== "value" && (needWarn = true);
      renderData = data;
    }
    warn && needWarn && console.warn((field.code ? field.code + "数据格式问题, " : "") + 'multiSelect/multiTreeSelect 组件支持的数据格式建议统一使用 [{${showFiled}:"", ${idField}:""}]');
  }
  return renderData;
}